import React, { useCallback, useEffect, useRef, useState } from "react";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import {
  classSection,
  count,
  durationOne,
  examOne,
  examTypeOptions,
  maxMark,
  minMark,
  startTime,
  startTimeOne,
} from "../../../../core/common/selectoption/selectoption";
import Select, { SingleValue } from "react-select";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { examSchedule } from "../../../../core/data/json/exam_schedule";
import { TableData } from "../../../../core/data/interface";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { all_routes } from "../../../router/all_routes";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get, _post } from "../../../Utils/Helper";
import { TimePicker } from "antd";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { values } from "../../../../style/icon/fontawesome/js/v4-shims";

const ExamSchedule = () => {
  dayjs.extend(duration);
  const { classes, user, academic_calendar } = useSelector(
    (state: any) => state.auth
  );
  const [subjects, setSubjects] = useState([]);

  const classOptions = classes?.map((x: any) => ({
    value: x.class_code,
    label: x.class_name,
  }));
  const subjectOption = subjects?.map((x: any) => ({
    value: x.subject_code,
    label: x.subject,
  }));

  interface ExamsCalendar {
    id: number;
    title: string;
    exam_type: string;
    start_date: string;
    end_date: string;
  }

  interface FormType {
    id?: string;
    invigilator: string;
    subject_code: string;
    start_time: Date | null;
    end_time: Date | null;
    class_name: string;
    examinations_hall: string;
    duration: string;
    exam_date: string;
    title: string;
    exam_type: string;
    subject_name: string;
    class_code: string;
    schedule_name: string;
    query_type?: string;
  }

  const _form: FormType = {
    invigilator: "",
    subject_code: "",
    start_time: null,
    end_time: null,
    examinations_hall: "",
    class_name: "",
    duration: "",
    exam_date: "",
    title: "", // Corrected property name
    exam_type: "",
    subject_name: "",
    schedule_name: "",
    class_code: "",
    query_type: "select-all",
  };

  const routes = all_routes;
  // const data = examSchedule;
  // const [examSchedules, setExamSchedules] = useState([]);
  const [form, setForm] = useState(_form);
  const [teacherNames, setTeacherNames] = useState([]);

  const getModalContainer2 = () => {
    const modalElement = document.getElementById("modal_datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const navigate = useNavigate();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    getExamSchedules();
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (query_type: string) => {
    _post(
      "examinations?query_type=create",
      {
        ...form,
        query_type,
        term: academic_calendar[0]?.term,
        academic_year: academic_calendar[0]?.academic_year,
      },
      (res) => {
        if (res.success) {
          toast.success("Submitted successfully");
          getExamSchedules();
        }
      },
      (err) => {
        // Handle error
        console.error("Submission failed:", err);
      }
    );

    // Reset the form after submission
    setForm(_form);
  };

  const [loading, setLoading] = useState(false);

  const [examSchedules, setExamSchedules] = useState([]);
  const [examsCalendar, setExamsCalendar] = useState<ExamsCalendar[]>([]);

  const getCalendars = () => {
    setLoading(true);
    _get(
      `exam_calendar?query_type=select-all`,
      (res) => {
        if (res.success) {
          setLoading(false);
          setExamsCalendar(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
    _get(
      "teachers?query_type=select-all",
      (res) => {
        if (res.success) {
          setLoading(false);
          setTeacherNames(res.results);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };
  const getExamSchedules = useCallback(() => {
    _get(
      `examinations?query_type=${form.query_type}&class_name=${form.class_name}&subject=${form.subject_code}`,
      (res) => {
        if (res.success) {
          setLoading(false);
          setExamSchedules(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, [form.query_type, form.class_name, form.subject_code]);
  useEffect(() => {
    getExamSchedules();
  }, [getExamSchedules]);
  useEffect(() => {
    getCalendars();
    _get(
      `subjects?query_type=select-section-subjects&class_code=${form.class_code}&school_id=${user.school_id}`,
      (res) => {
        if (res.success && res.data && res.data.length) {
          setSubjects(res.data);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, [form.class_code]);

  const examScheduleOptions = examsCalendar.length
    ? examsCalendar.map((cal: any) => ({ label: cal.exam_name, value: cal.id }))
    : [];

  const teacherOptions = teacherNames?.map((i: any) => ({
    label: i.name,
    value: i.name,
  }));
  const [newContents, setNewContents] = useState<number[]>([0]);
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },

    {
      title: "Subject",
      dataIndex: "subject_name",
      // render: (text: string, record: any, index: number) => (
      //   <>
      //     <Link to="#" className="link-primary">
      //       {record.subject_name}{" "}
      //     </Link>
      //   </>
      // ),
    },

    {
      title: "Class",
      dataIndex: "class_name",
      // sorter: (a: TableData, b: TableData) =>
      //   a.startTime.length - b.startTime.length,
    },
    {
      title: "Exam Date",
      dataIndex: "exam_date",
      // sorter: (a: TableData, b: TableData) =>
      //   a.examDate.length - b.examDate.length,
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      // sorter: (a: TableData, b: TableData) =>
      //   a.startTime.length - b.startTime.length,
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      // sorter: (a: TableData, b: TableData) =>
      //   a.endTime.length - b.endTime.length,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      // sorter: (a: TableData, b: TableData) =>
      //   a.duration.length - b.duration.length,
    },
    {
      title: "Invegelator",
      dataIndex: "invigilator",
      // sorter: (a: TableData, b: TableData) =>
      //   a.duration.length - b.duration.length,
    },
    // {
    //   title: "Attendance",
    //   dataIndex: "id",
    //   render: (text: string, record: any, index: number) => (
    //     <Link
    //       className="btn btn-primary btn-small"
    //       to={`${all_routes.examAttendance}?exam_id=${record.id}&subject=${record.subject}&class_name=${record.class_name}`}
    //       onClick={() =>
    //         navigate(
    //           `${all_routes.examAttendance}?exam_id=${record.id}&subject=${record.subject}&class_name=${record.class_name}`
    //         )
    //       }
    //     >
    //       Attendace
    //     </Link>
    //   ),
    // },
    // {
    //   title: "Max Mark",
    //   dataIndex: "maxMarks",
    //   // sorter: (a: TableData, b: TableData) =>
    //   //   a.maxMarks.length - b.maxMarks.length,
    // },
    // {
    //   title: "Min Mark",
    //   dataIndex: "minMarks",
    //   // sorter: (a: TableData, b: TableData) =>
    //   //   a.minMarks.length - b.minMarks.length,
    // },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: any, index: number) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                onClick={() => {
                  setForm((prev) => ({ ...prev, ...record }));
                }}
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_exam_schedule"
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    const { start_time, end_time } = form;
  
    if (start_time && end_time) {
      const start = dayjs(start_time);
      const end = dayjs(end_time);
  
      // Check if start_time is greater than end_time
      if (start.isAfter(end)) {
        setForm((prev) => ({
          ...prev,
          end_time: null, // Reset end_time
        }));
        toast.error("End time cannot be earlier than start time");
        return; // Exit early
      }
  
      // Calculate duration
      const diff = end.diff(start);
      const durationObj = dayjs.duration(diff);
  
      const totalMinutes = durationObj.asMinutes();
  
      let durationFormatted = "";
      if (totalMinutes < 60) {
        durationFormatted = `${Math.round(totalMinutes)} mins`;
      } else {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = Math.round(totalMinutes % 60);
        durationFormatted = `${hours} hr${hours > 1 ? "s" : ""} ${minutes ? `${minutes} min${minutes > 1 ? "s" : ""}` : ""}`.trim();
      }
  
      setForm((prev) => ({
        ...prev,
        duration: durationFormatted,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        duration: "",
      }));
    }
  }, [form.start_time, form.end_time]);
  

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };
  const removeContent = (index: any) => {
    setNewContents(newContents.filter((_, i) => i !== index));
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Exam Schedule</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Academic </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Exam Schedule
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_exam_schedule"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Exam Schedule
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Exam Schedule</h4>
              <div className="d-flex align-items-center flex-wrap">
                {/* <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div> */}
                {/* <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={classOptions}
                                handleChange={(newValue: SingleValue<Option>) =>
                                  setForm((prev) => ({
                                    ...prev,
                                    class_name: newValue ? newValue.value : "",
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-12F">
                          <div className="mb-3">
                            <label className="form-label">Subject</label>
                            <CommonSelect
                              className="select"
                              options={subjectOption}
                              defaultValue={{
                                label: form.subject,
                                value: form.subject,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  subject: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div> */}
                {/* <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* {JSON.stringify([
                academic_calendar[0]?.academic_year,
                academic_calendar[0]?.term,
              ])} */}
              {/* Guardians List */}
              <Table
                dataSource={examSchedules}
                columns={columns}
                Selection={false}
              />

              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Add Exam Schedule */}
        <div className="modal fade" id="add_exam_schedule">
          <div className="modal-dialog modal-dialog-centered  modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Exam Schedule</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              {/* {JSON.stringify(form)} */}
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4">
                          {/* {JSON.stringify(new_subjet)} */}
                          <div className="mb-3">
                            <label className="form-label">Exam Type</label>
                            <CommonSelect
                              className="select"
                              options={examTypeOptions}
                              defaultValue={{
                                label: form.exam_type,
                                value: form.exam_type,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  exam_type: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4"> */}
                        {/* {JSON.stringify(examScheduleOptions)} */}
                        {/* <div className="mb-3">
                            <label className="form-label">Exam Source</label>
                            <CommonSelect
                              className="select"
                              options={examScheduleOptions}
                              defaultValue={{
                                label: form.schedule_name,
                                value: form.schedule_id,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  schedule_id: newValue ? newValue.value : "",
                                  schedule_name: newValue ? newValue.label : "",
                                }))
                              }
                            />
                          </div> */}
                        {/* </div> */}
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={classOptions}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  class_name: newValue ? newValue.label : "",
                                  class_code: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            {/* {JSON.stringify(form.subject_code)} */}
                            <label className="form-label">Subject</label>
                            <CommonSelect
                              className="select"
                              options={subjectOption}
                              // defaultValue={{
                              //   label: form.subject,
                              //   value: form.subject,
                              // }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  subject_code: newValue ? newValue.value : "",
                                  subject_name: newValue ? newValue.label : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              Exam Description
                            </label>
                            <input
                              className="form-control"
                              value={form.title}
                              name="title"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="exam_date"
                              value={form.exam_date}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Start Time</label>
                            <div className="date-pic">
                              <TimePicker
                                getPopupContainer={getModalContainer2}
                                use12Hours
                                placeholder="Choose"
                                format="h:mm A"
                                className="form-control timepicker"
                                name="start_time"
                                onChange={(time) => {
                                  // Check if a valid time is selected
                                  if (time) {
                                    setForm((prev) => ({
                                      ...prev,
                                      start_time: time.toDate(), // Store as Date object
                                    }));
                                  } else {
                                    setForm((prev) => ({
                                      ...prev,
                                      start_time: null, // Reset if no valid time is selected
                                    }));
                                  }
                                }}
                              />
                              <span className="cal-icon">
                                <i className="ti ti-clock" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">End Time</label>
                            <div className="date-pic">
                              <TimePicker
                                getPopupContainer={getModalContainer}
                                use12Hours
                                placeholder="Choose"
                                format="h:mm A"
                                className="form-control timepicker"
                                name="end_time"
                                onChange={(time) => {
                                  // Check if a valid time is selected
                                  if (time) {
                                    setForm((prev) => ({
                                      ...prev,
                                      end_time: time.toDate(), // Store as Date object
                                    }));
                                  } else {
                                    setForm((prev) => ({
                                      ...prev,
                                      end_time: null, // Reset if no valid time is selected
                                    }));
                                  }
                                }}
                              />

                              <span className="cal-icon">
                                <i className="ti ti-clock" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Duration(min)</label>
                            <input
                              className="form-control"
                              disabled={true}
                              value={form.duration}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Invigilator</label>
                            <CommonSelect
                              className="select"
                              options={teacherOptions}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  invigilator: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => handleSubmit("create")}
                  >
                    Add Exam Schedule
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Exam Schedule */}
        {/* Edit Exam Schedule */}
        <div className="modal fade" id="edit_exam_schedule">
          <div className="modal-dialog modal-dialog-centered  modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Exam Schedule</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              {/* {JSON.stringify(form)} */}
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4">
                          {/* {JSON.stringify(new_subjet)} */}
                          <div className="mb-3">
                            <label className="form-label">Exam Type</label>
                            <CommonSelect
                              className="select"
                              options={examTypeOptions}
                              defaultValue={{
                                label: form.exam_type,
                                value: form.exam_type,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  exam_type: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        {/* {JSON.stringify(examScheduleOptions)} */}
                        {/* <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Exam Source</label>
                            <CommonSelect
                              className="select"
                              options={examScheduleOptions}
                              defaultValue={{
                                label: form.schedule_name,
                                value: form.schedule_id,
                              }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  schedule_id: newValue ? newValue.value : "",
                                  schedule_name: newValue ? newValue.label : "",
                                }))
                              }
                            />
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={classOptions}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  class_name: newValue ? newValue.label : "",
                                  class_code: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Subject</label>
                            <CommonSelect
                              className="select"
                              options={subjectOption}
                              // defaultValue={{
                              //   label: form.subject,
                              //   value: form.subject,
                              // }}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  subject_code: newValue ? newValue.value : "",
                                  subject_name: newValue ? newValue.label : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Exam Title</label>
                            <input
                              className="form-control"
                              value={form.title}
                              name="title"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="exam_date"
                              value={form.exam_date}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Start Time</label>
                            <div className="date-pic">
                              <TimePicker
                                getPopupContainer={getModalContainer2}
                                use12Hours
                                placeholder="Choose"
                                format="h:mm A"
                                className="form-control timepicker"
                                name="start_time"
                                onChange={(time) => {
                                  // Check if a valid time is selected
                                  if (time) {
                                    setForm((prev) => ({
                                      ...prev,
                                      start_time: time.toDate(), 
                                    }));
                                  } else {
                                    setForm((prev) => ({
                                      ...prev,
                                      start_time: null,
                                    }));
                                  }
                                }}
                              />
                              <span className="cal-icon">
                                <i className="ti ti-clock" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">End Time</label>
                            <div className="date-pic">
                              <TimePicker
                                getPopupContainer={getModalContainer}
                                use12Hours
                                placeholder="Choose"
                                format="h:mm A"
                                className="form-control timepicker"
                                name="end_time"
                                onChange={(time) => {
                                  // Check if a valid time is selected
                                  if (time) {
                                    setForm((prev) => ({
                                      ...prev,
                                      end_time: time.toDate(), // Store as Date object
                                    }));
                                  } else {
                                    setForm((prev) => ({
                                      ...prev,
                                      end_time: null, // Reset if no valid time is selected
                                    }));
                                  }
                                }}
                              />

                              <span className="cal-icon">
                                <i className="ti ti-clock" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Duration(min)</label>
                            <input
                              className="form-control"
                              disabled={true}
                              value={form.duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">Invigilator</label>
                            <CommonSelect
                              className="select"
                              options={teacherOptions}
                              handleChange={(newValue: SingleValue<Option>) =>
                                setForm((prev) => ({
                                  ...prev,
                                  invigilator: newValue ? newValue.value : "",
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => handleSubmit("update")}
                  >
                    Submit
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit Exam Schedule */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      onClick={() => handleSubmit("delete")}
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default ExamSchedule;
